import { Alert } from '@efexteam/components';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RemainingTimeStyle from './RemainingTime.style';
import {
  EXPIRATION_TIME,
  HOURS,
  INTERVAL_TIME,
  MINUTES,
  SECONDS,
} from './constants';

const RemainingTime = () => {
  const { t } = useTranslation();
  const [remainingTime, setRemainingTime] = useState(EXPIRATION_TIME);

  const formatTime = (seconds: number) => {
    const days = Math.floor(seconds / (HOURS * MINUTES * SECONDS));
    const hours = Math.floor(
      (seconds % (HOURS * MINUTES * SECONDS)) / (MINUTES * SECONDS)
    );
    const minutes = Math.floor((seconds % (MINUTES * SECONDS)) / SECONDS);

    const timeString = [
      days ? `${days} ${t('appBnfRemainingTimeDays')}` : '',
      hours ? `${hours} ${t('appBnfRemainingTimeHours')}` : '',
      minutes ? `${minutes} ${t('appBnfRemainingTimeMinutes')}` : '',
    ]
      .filter(Boolean)
      .join(', ');

    return timeString || '0 minutes';
  };

  useEffect(() => {
    if (remainingTime <= 0) return undefined;

    const interval = setInterval(() => {
      setRemainingTime((prev) => prev - 1);
    }, INTERVAL_TIME);

    return () => clearInterval(interval);
  }, [remainingTime]);

  return (
    <Alert
      severity="info"
      variant="outlined"
      icon={<TimerOutlinedIcon sx={{ fontSize: 20 }} />}
      className={RemainingTimeStyle.AlertWrapper}
    >
      <Typography variant="body2">{t('appBnfRemainingTime')}</Typography>
      <Typography variant="body2">{formatTime(remainingTime)}</Typography>
    </Alert>
  );
};

export default RemainingTime;
